import { IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { RhfControlledTableToolbarProps } from "./RhfControlledTableToolbarProps";

export const RhfControlledTableToolbar = ({
  itemSelected,
  handleAddItem,
  handleDeleteItem,
  additionalItems,
  disableMutationButtons,
  ...props
}: RhfControlledTableToolbarProps) => {
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
      {...props}
    >
      <Typography sx={{ flex: "1 1 100%" }} variant="h6" component="div">
        {/* Here sits the headline for the  table */}
      </Typography>
      <Tooltip title="ADD">
        <span>
          <IconButton onClick={handleAddItem} disabled={disableMutationButtons}>
            <AddIcon />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="DELETE">
        <span>
          <IconButton disabled={disableMutationButtons || !itemSelected} onClick={handleDeleteItem}>
            <DeleteIcon />
          </IconButton>
        </span>
      </Tooltip>
      {additionalItems &&
        additionalItems.map((item) => (
          <Tooltip title={item.label}>
            <span>
              <IconButton onClick={item.onClick} disabled={item?.disabled}>
                {item.icon}
              </IconButton>
            </span>
          </Tooltip>
        ))}
    </Toolbar>
  );
};
